import { RegionShared } from "@1games-ru/region-shared";
import { useCallback, useEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  chatIsOpenSelector,
  setChatActive,
  setChatEnable,
  setChatOpen,
  setChatShow,
  setFastMessage,
} from "@/domains/chat/slice";
import useMessagesControl from "@/domains/chat/hooks/useMessagesControl";

export default () => {
  const { pushMessage, clearMessages } = useMessagesControl();
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(chatIsOpenSelector);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Chat.SetInputStatus, () => {
      if (!isOpen) {
        dispatch(setFastMessage(true));
      }
      dispatch(setChatOpen(true));
      dispatch(setChatEnable(true));
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Chat.SetInputStatus);
    };
  }, [dispatch, isOpen]);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Chat.SetChatShow, () => {
      dispatch(setChatShow(true));
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Chat.SetChatShow);
    };
  }, [dispatch]);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Chat.SetChatHide, () => {
      dispatch(setChatShow(false));
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Chat.SetChatHide);
    };
  }, [dispatch]);

  const activateChat = useCallback((flag: boolean) => dispatch(setChatActive(flag)), [dispatch]);

  useEffect(() => {
    const chatAPI = {
      "chat:push": pushMessage,
      "chat:clear": clearMessages,
      "chat:activate": activateChat,
    };

    Object.keys(chatAPI).forEach((fn) => {
      mp?.events?.add(fn, chatAPI[fn]);
    });

    return () => {
      Object.keys(chatAPI).forEach((fn) => {
        mp?.events?.remove(fn);
      });
    };
  }, []);
};
